import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { EntBasicHB } from "../../../../../models/handBooks/basicHB";
import {
  useAddRegisterStatusMutation,
  useDeleteRegisterStatusMutation,
  useEditRegisterStatusMutation
} from "../../../../../redux/api/handBooksApi/organic/registerStatusApi";

const useRegisterStatus = (modal: any, refresh?: () => void) => {
  const { t } = useTranslation()
  const { confirm } = modal;
  const [addRegisterStatus] = useAddRegisterStatusMutation();
  const [deleteRegisterStatus] = useDeleteRegisterStatusMutation();
  const [editRegisterStatus] = useEditRegisterStatusMutation();

  async function onAddRegisterStatus(newRegisterStatus: EntBasicHB): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await addRegisterStatus(newRegisterStatus).then((response: any) => {
		if (response.error !== undefined) {

		  throw new Error(response.error.data.message);
		}
		if (response.data.success) {
		  status = true;
		  message.success(t('msg.successAdd'));
		  if (refresh) refresh();
		}
	  }).catch((error: any) => {
		modal.error({ title: t('msg.error'), content: String(error.message) });

	  });
	  return status;
	} catch (error: any) {
	  modal.error({ title: t('msg.error'), content: String(error.message) });
	  return false;
	}
  }

  async function onDeleteRegisterStatus(registerStatus: EntBasicHB) {
	try {
	  let status: boolean = false;
	  confirm({
		centered: true,
		title: t('msg.confirmDeleteText'),
		okText: t('general.yes'),
		cancelText: t('general.no'),
		onOk() {
		  deleteRegisterStatus(registerStatus.id).then((response: any) => {
			if (response.error !== undefined && response.error.status === 400) {
			  status = false;
			  throw new Error(response.error.data.message);
			}
			if (response.data.success) {
			  status = true;
			  Modal.success({ title: t('msg.successDelete') });
			  if (refresh) refresh();
			}
		  }).catch((error: any) => {
			Modal.error({ title: t('msg.error'), content: String(error.message) });

		  });
		}
	  })
	  return status
	} catch (error: any) {
	  Modal.error({ title: t("msg.error"), content: String(error.message) });
	  return false;
	}
  };

  async function onEditRegisterStatus(editedRegisterStatus: EntBasicHB): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await editRegisterStatus(editedRegisterStatus).then((response: any) => {
		if (response.error !== undefined && response.error.status === 400) {
		  throw new Error(response.error.data.message);
		}
		if (response.data.success) {
		  status = true;
		  Modal.success({ title: t('msg.successEdited') });
		  if (refresh) refresh();
		}
	  }).catch((error: any) => {
		Modal.error({ title: t('msg.error'), content: String(error.message) });
	  });
	  return status;
	} catch (error: any) {
	  Modal.error({ title: t("msg.error"), content: String(error.message) });
	  return false;
	}
  };
  return { onAddRegisterStatus, onDeleteRegisterStatus, onEditRegisterStatus }

}
export { useRegisterStatus };

